<template>
  <div class="payXQ">
    <div class="gong_neng">
      <el-button @click="$router.go(-1)">返回</el-button>
      <el-date-picker
        style="width: 200px"
        v-model="monthValue"
        type="month"
        value-format="yyyy-M"
        :clearable="false"
        placeholder="选择筛选月份"
        @change="monthChange"
      >
      </el-date-picker>
    </div>
    <div class="gong_neng"></div>
    <el-table :data="tableData" style="width: 100%">
      <template v-for="(item, index) in title">
        <el-table-column
          v-if="item.field != 'CZFS'"
          :key="index"
          :prop="item.field"
          :label="item.name"
          align="center"
        >
        </el-table-column>
        <el-table-column
          v-else
          :key="index"
          :prop="item.field"
          :label="item.name"
          align="center"
        >
          <template slot-scope="scope">
            <span
              >{{ scope.row.recharge_amount }} 元 /
              {{ scope.row.resume_point }} 份
            </span>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";
export default {
  data() {
    return {
      tableData: [],
      title: [
        { field: "pay_time_str", name: "充值日期" },
        { field: "CZFS", name: "充值方式" },

        { field: "real_amount", name: "实际充值金额" },
        { field: "remain_resume_point", name: "剩余简历份数" },
        { field: "resume_red_packet", name: "使用简历红包" },
        { field: "resume_end_time_str", name: "简历下载到期日期" },
      ],
      monthValue: "",
    };
  },
  methods: {
    monthChange() {
      if (!this.monthValue) {
        this.$message.warning("请选择筛选月份");
      }
      this.init(this.monthValue.split("-")[0], this.monthValue.split("-")[1]);
    },
    init(year = "", month = "") {
      require("post", "/hr24_index_data/v1/seed_recharge_info/", {
        user_detail_id: this.$route.query.id,
        year,
        month,
      }).then((res) => {
        if (!res.code) {
          console.log(res);
          this.tableData = res.data;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
  },
  created() {
    this.init();
  },
};
</script>

<style>
.payXQ {
  margin-top: 46px;
  margin-left: 229px;
  background: #ffff;
  min-height: 70vh;
  margin-bottom: 20px;
  width: 80vw;
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
  padding: 50px;
}
</style>


// WEBPACK FOOTER //
// src/index/payXQ.vue